module.exports = __webpack_public_path__ + "img/main_kitchenl1.4ca41fad.jpg";